import { FC } from 'react';
import SectionTitle from 'components/shared/generic/sectionTitle/presentational/SectionTitle';
import PageContainer from 'components/shared/generic/pageContainer/presentational/PageContainer';
import BulletPoint from 'components/shared/generic/bulletPoint/presentational/BulletPoint';
import Button from 'components/shared/generic/button/presentational/Button';
import { MORE } from 'constants/shared/routes';
import {
    SUITS_ME_REFER_FRIEND,
    SUITS_ME_REFER_TERMS_AND_CONDITIONS,
} from 'lib/constants/routes';
import useTranslate from 'lib/languages/useTranslate';
import { useLocation } from 'react-router';
import jwt_decode from 'jwt-decode';
import Typography from 'components/shared/generic/typography/presentational/Typography';
import useCopyToClipboard from '../../../../../utils/hooks/useCopyToClipboard';

const ReferAFriend: FC = () => {
    const translate = useTranslate('referAFriend');
    const termsTranslate = useTranslate('termsAndConditions');
    const location = useLocation();

    const accessToken = localStorage.getItem('accessToken');
    const { usernameV1 } = accessToken
        ? jwt_decode<{ usernameV1: string }>(accessToken)
        : { usernameV1: 'user' };

    const [isCopied, onCopy] = useCopyToClipboard();

    const shareUrl = `${SUITS_ME_REFER_FRIEND}?utm_source=refer_a_friend&utm_medium=referral&utm_campaign=in_app_banner_${usernameV1}`;

    const handleTermsClick = () => {
        window.open(SUITS_ME_REFER_TERMS_AND_CONDITIONS);
    };

    const backRoute = (location.state as any)?.backRoute || MORE;

    return (
        <PageContainer className="more-refer-a-friend-container">
            <SectionTitle
                title={translate('breadcrumbText')}
                backRoute={backRoute}
            />
            <div className="refer-a-friend-container">
                <h2 className="subtitle">{translate('titleText')}</h2>
                <h2 className="headline">{translate('inviteText')}</h2>

                <Typography className="text">
                    {translate('bulletsInfoText', {
                        boldText7: <strong>{translate('boldText7')}</strong>,
                    })}
                </Typography>
                <Typography className="text mt-2">
                    {translate('bulletsInfoText2', {
                        boldText5: <strong>{translate('boldText5')}</strong>,
                    })}
                </Typography>
                <h2 className="headline mt-2">{translate('howItWorks')}</h2>
                <BulletPoint
                    html
                    leftText={`<strong>${translate(
                        'inviteYourFriends',
                    )}</strong> ${translate('directFriends')}.`}
                />
                <BulletPoint
                    html
                    leftText={`<strong>${translate(
                        'contactUs',
                    )}</strong> ${translate('sendEmail')}`}
                />
                <BulletPoint
                    html
                    leftText={`<strong>${translate('earnMoney')}</strong>`}
                />
                <BulletPoint
                    className="indented-bullet"
                    html
                    leftText={`<strong>${translate(
                        'earnMoneyStep1',
                    )}</strong> - ${translate('earnMoneyStep1Info')}`}
                />
                <BulletPoint
                    className="indented-bullet"
                    html
                    leftText={`<strong>${translate(
                        'earnMoneyStep2',
                    )}</strong> - ${translate('earnMoneyStep2Info')}`}
                />
                <BulletPoint
                    className="indented-bullet"
                    html
                    leftText={`<strong>${translate(
                        'earnMoneyStep3',
                    )}</strong> - ${translate('earnMoneyStep3Info')}`}
                />
                <Typography className="text">
                    {translate('allStepCompleted', {
                        boldText1: <strong>{translate('boldText1')}</strong>,
                        boldText2: <strong>{translate('boldText2')}</strong>,
                    })}
                </Typography>
                <Typography className="text mt-2">
                    {translate('makeSure', {
                        boldText2: <strong>{translate('boldText2')}</strong>,
                    })}
                </Typography>
            </div>
            <div className="refer-a-friend-faqs-container">
                <h2 className="headline">{translate('referFAQS.title')}</h2>

                <BulletPoint
                    html
                    leftText={`<strong>${translate(
                        'referFAQS.howToTitle',
                    )}</strong> - ${translate('referFAQS.howToDescription', {
                        boldText2: `<strong>${translate('boldText2')}</strong>`,
                    })}.`}
                />

                <BulletPoint
                    html
                    leftText={`<strong>${translate(
                        'referFAQS.whenTitle',
                    )}</strong> - ${translate('referFAQS.whenDescription', {
                        boldText3: `<strong>${translate('boldText3')}</strong>`,
                        boldText4: `<strong>${translate('boldText4')}</strong>`,
                    })}.`}
                />

                <BulletPoint
                    html
                    leftText={`<strong>${translate(
                        'referFAQS.howManyTitle',
                    )}</strong> - ${translate('referFAQS.howManyDescription', {
                        boldText1: `<strong>${translate('boldText1')}</strong>`,
                        boldText5: `<strong>${translate('boldText5')}</strong>`,
                    })}.`}
                />

                <BulletPoint
                    html
                    leftText={`<strong>${translate(
                        'referFAQS.canITrackTitle',
                    )}</strong> - ${translate(
                        'referFAQS.canITrackDescription',
                    )}.`}
                />

                <BulletPoint
                    html
                    leftText={`<strong>${translate(
                        'referFAQS.canIReferTitle',
                    )}</strong> - ${translate(
                        'referFAQS.canIReferDescription',
                        {
                            boldText6: `<strong>${translate(
                                'boldText6',
                            )}</strong>`,
                        },
                    )}.`}
                />
            </div>
            <Button
                disabled={isCopied}
                className="refer-a-friend-button"
                onClick={() => onCopy(shareUrl)}
            >
                {translate('emailUs')}
            </Button>
            <Button
                className="refer-a-friend-button"
                onClick={handleTermsClick}
            >
                {termsTranslate('breadcrumbText')}
            </Button>
        </PageContainer>
    );
};

export default ReferAFriend;
